import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';

import { toast } from 'react-toastify';

import { PageTitle, SimplePopup } from 'components';

import { ManageToolbar, ManageTable, RegisterManage } from './components';
import { IsNoU } from 'common/utils';

// >> redux
import {
  getUsers,
  addUser,
  updateUser,
  deleteUser,
  findUser,
  removeUser,

  getAreas,
  addArea,
  updateArea,
  deleteArea,
  findArea,
  removeArea,

  getGroups,
  addGroup,
  updateGroup,
  deleteGroup,
  findGroup,
  removeGroup,

  getRules,
//  addRule,
  updateRule,
//  deleteRule,
} from '../../redux/actions/manage';
// <<

// >> redux
import {
  getAgencies,
  getClients,
} from 'redux/actions/companies';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Manage = (props) => {
  const classes = useStyles();

  const { type } = props.match.params;

  const { 
    users, 
    areas, 
    reged_areas, 
    groups, 
    rules, 
    agencies, 
    clients, 
    loading, 
    loading_find_manage,
    manage_total 
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [modeRegisterManage, setModeRegisterManage] = useState(true);
  const [openRegisterManage, setOpenRegisterManage] = useState(false);

  const [disableEditButton, setDisableEditButton] = useState(true);
  const [disableDeleteButton, setDisableDeleteButton] = useState(true);

  const [editItem, setEditItem] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);

  const [find_data, set_find_data] = useState({});

  const handleClickFind = (name) => {

    let find = {};

    if (IsNoU(name) || name.length > 0) {
      find.user_name = name;
    }

    find.page = 0;
    find.rows_per_page = rowsPerPage;

    set_find_data(find);

    if (type === 'user')
      props.findUser(find);
    else if (type === 'area')
      props.findArea(find);
    else if (type === 'group')
      props.findGroup(find);
  }

  const handleClickOpenRegister = () => {

    if (type === 'group' && (IsNoU(reged_areas) || reged_areas.length <= 0)) {
      toast("권역 사항이 없습니다. 권역을 먼저 입력하세요.");
      return ;
    }

    setEditItem(null);
    setModeRegisterManage(true);
    setOpenRegisterManage(true);
  }
  
  const handleClickOpenEdit = () => {

    if (selectedItems.length !== 1){
      return ;
    }
    const id = selectedItems[0];
    let selectedItem = null;
    if (type === 'user') {
      selectedItem = users.find(user => (user.id === id));
      if (selectedItem.userid === 'admin') {
        return
      }
    }
    else if (type === 'area')
      selectedItem = areas.find(area => (area.id === id));
    else if (type === 'group')
      selectedItem = groups.find(group => (group.id === id));
    else if (type === 'rule')
      selectedItem = rules.find(rule => (rule.id === id));

    //console.log(selectedItem);
    setEditItem(selectedItem);

    setModeRegisterManage(false);
    setOpenRegisterManage(true);
  }

  const handleClickCloseRegisterManage = () => {
    setOpenRegisterManage(false);
  }

  const handleClickSave = (item) => {

    setPage(0);
    setRowsPerPage(10);

    if (type === 'user') {
      if (modeRegisterManage) {
        props.addUser(item);
      }
      else if (!modeRegisterManage && selectedItems.length === 1)
      {
        props.updateUser(item.id, item);
      }
    }
    else if (type === 'area') {
      if (modeRegisterManage) {
        props.addArea(item);
      }
      else if (!modeRegisterManage && selectedItems.length === 1)
      {
        props.updateArea(item.id, item);
      }
    }
    else if (type === 'group') {
      if (modeRegisterManage) {
        props.addGroup(item);
      }
      else if (!modeRegisterManage && selectedItems.length === 1)
      {
        props.updateGroup(item.id, item);
      }
    }
    else if (type === 'rule') {
      if (modeRegisterManage) {
//        props.addRule(device);
      }
      else if (!modeRegisterManage && selectedItems.length === 1)
      {
        props.updateRule(item.id, item);
      }
    }
    setOpenRegisterManage(false);
  }

  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);

  const handleClickOpenDelete = () => {
    if (selectedItems.length === 0){
      return ;
    }
    setOpenDeleteAlert(true);
  };

  const handleClickCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  }
  const handleClickDeleteAlertOk = () => {

    //console.log('handleClickDeleteAlertOk -> ' + selectedTemplates.length);
    if (selectedItems.length === 0){
      return ;
    }

    let deletes;
    if (type === 'user') {
      deletes = selectedItems.map((selected)=>{
        return users.find(user => (user.id === selected));
      });
      props.deleteUser(deletes);
    }
    else if (type === 'area') {
      deletes = selectedItems.map((selected)=>{
        return areas.find(area => (area.id === selected));
      });
      props.deleteArea(deletes);
    }
    else if (type === 'group') {
      deletes = selectedItems.map((selected)=>{
        return groups.find(group => (group.id === selected));
      });
      props.deleteGroup(deletes);
    }
    else if (type === 'rule') {
      // deletes = selectedItems.map((selected)=>{
      //   return rules.find(rule => (rule.id === selected));
      // });
      //props.deleteRule(deletes);
    }

    //console.log('handleClickDeleteAlertOk -> ' + type + ',' + deletes);
    setOpenDeleteAlert(false);
  }

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handlePageChange = (event, page) => {
    setPage(page);
    let find_page_data = find_data;
    find_page_data.page = page;
    set_find_data(find_page_data);

    if (type === 'user')
      props.findUser(find_page_data);
    else if (type === 'area')
      props.findArea(find_page_data);
    else if (type === 'group')
      props.findGroup(find_page_data);
  };

  const handleRowsPerPageChange = e => {
    let rows_per_page = e.target.value;
    setRowsPerPage(rows_per_page);
    setPage(0);

    let find_page_data = find_data;
    find_page_data.page = 0;
    find_page_data.rows_per_page = rows_per_page;
    set_find_data(find_page_data);

    if (type === 'user')
      props.findUser(find_page_data);
    else if (type === 'area')
      props.findArea(find_page_data);
    else if (type === 'group')
      props.findGroup(find_page_data);
  };

  useEffect(() => {

    props.getAgencies();
    props.getClients();

    const jwt = localStorage.getItem('jwt');

    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }

    if (type === 'rule')
       props.getRules();

    return () => {
      //console.log("componentDidUnmount");

      props.removeUser();
      props.removeArea();
      props.removeGroup();
    };
  }, []); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');

    //props.getAreas();
 
    if (type !== 'user') props.removeUser();
    if (type !== 'area') props.removeArea();
    if (type !== 'group') props.removeGroup(); 

    //props.removeArea();
    if (type === 'group') {
      props.getAreas();
    }
    if (type === 'rule')
       props.getRules();
    // if (type === 'user')
    //   props.getUsers();
    // else if (type === 'area')
    //   props.getAreas();
    // else if (type === 'group')
    //   props.getGroups();
    // else if (type === 'rule')
    //   props.getRules();

  }, [type]);

  // useEffect(() => {
  //   //console.log('componentDidUpdate & selectedTemplates changed');
 
  //   setDisableEditButton(selectedSettlement.length != 1);
  //   setDisableDeleteButton(selectedSettlement.length < 1);

  // }, [selectedSettlement]);

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');
 
    setDisableEditButton(selectedItems.length !== 1);
    setDisableDeleteButton(selectedItems.length < 1);

  }, [selectedItems]);

  if (loading) {
    return <WaveLoading />;
  }
  
  return (
    <div className={classes.root}>

      {type !== 'user' && 
      type !== 'area' && 
      type !== 'group' && 
      type !== 'rule' && 
      <Redirect to="/not-found"/>}

      <PageTitle
        pageTitle={type === 'user'? '사용자 관리' : type === 'area'? '권역 관리' : type === 'group'? '그룹 관리' : '광고 유효 시간'}
        />

      <ManageToolbar 
        type={type}

        onClickFind={handleClickFind}
        />

      <div className={classes.content}>
        <ManageTable 
          userRole={userRole}
          type={type}
          items={
            type === 'user' ? users: 
            type === 'area' ? areas : 
            type === 'group' ? groups : 
            rules
          }
          onSetSelectedItems={//(checks) => {
            /*setSelectedUsers(checks)*/
            //if (type === 'user')
            //  setSelectedItems(checks);
            //}
            setSelectedItems
          }
          onClickOpenRegister={handleClickOpenRegister}
          onClickOpenEdit={handleClickOpenEdit}
          onClickOpenDelete={handleClickOpenDelete}
          disableEditButton={disableEditButton}
          disableDeleteButton={disableDeleteButton}

          openProgress={loading_find_manage}
          page={page}
          rowsPerPage={rowsPerPage}
          item_total={type === 'rule' ? rules.length : manage_total}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          />
      </div>

      <RegisterManage
        type={type}
        openDialog={openRegisterManage}
        modeRegisterDialog={modeRegisterManage}
        onClickCloseDialog={handleClickCloseRegisterManage}
        onClickSaveDialog={handleClickSave}

        mod_user={userName}
        editItem={editItem}
        areas={reged_areas}

        agencies={agencies}
        clients={clients}
        />

      <SimplePopup
        title={`선택한 데이터를 삭제하시겠습니까?`} 
        openPopup={openDeleteAlert} 
        onClickClose={handleClickCloseDeleteAlert} 
        onClickOk={handleClickDeleteAlertOk}
        />

    </div>
  );
};

//export default Manage;


Manage.propTypes = {
  loading: PropTypes.bool,
  users: PropTypes.arrayOf(PropTypes.object),
  areas: PropTypes.arrayOf(PropTypes.object),
  groups: PropTypes.arrayOf(PropTypes.object),
  rules: PropTypes.arrayOf(PropTypes.object),

  agencies: PropTypes.arrayOf(PropTypes.object),
  clients: PropTypes.arrayOf(PropTypes.object),
};

Manage.defaultProps = {
  loading: false,
  users: [],
  areas: [],
  reged_areas: [],
  groups: [],
  rules: [],

  agencies: [],
  clients: [],
};

const mapStateToProps = state => ({
  loading: state.manage.loading,
  loading_find_manage: state.manage.find_manage_loading,
  users: state.manage.userList,
  areas: state.manage.areaList,
  reged_areas: state.manage.reged_areaList,
  groups: state.manage.groupList,
  rules: state.manage.ruleList,
  manage_total: state.manage.manage_total,

  agencies: state.companies.reged_agencyList,
  clients: state.companies.reged_clientList,
});

const mapDispatchToProps = dispatch => ({
  getUsers: () => {getUsers(dispatch)},
  addUser: (user) => {addUser(user, dispatch)},
  updateUser: (id, user) => {updateUser(id, user, dispatch)},
  deleteUser: (deletes) => {deleteUser(deletes, dispatch)},
  findUser: (find) => {findUser(find, dispatch)},
  removeUser: () => {removeUser(dispatch)},

  getAreas: () => {getAreas(dispatch)},
  addArea: (area) => {addArea(area, dispatch)},
  updateArea: (id, area) => {updateArea(id, area, dispatch)},
  deleteArea: (deletes) => {deleteArea(deletes, dispatch)},
  findArea: (find) => {findArea(find, dispatch)},
  removeArea: () => {removeArea(dispatch)},

  getGroups: () => {getGroups(dispatch)},
  addGroup: (group) => {addGroup(group, dispatch)},
  updateGroup: (id, group) => {updateGroup(id, group, dispatch)},
  deleteGroup: (deletes) => {deleteGroup(deletes, dispatch)},
  findGroup: (find) => {findGroup(find, dispatch)},
  removeGroup: () => {removeGroup(dispatch)},

  getRules: () => {getRules(dispatch)},
//  addRule: (rule) => {addRule(rule, dispatch)},
  updateRule: (id, rule) => {updateRule(id, rule, dispatch)},
//  deleteRule: (deletes) => {deleteRule(deletes, dispatch)},

  getAgencies: () => {getAgencies(dispatch)},
  getClients: () => {getClients(dispatch)},
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Manage);

